import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { IconModule } from '@pu/ui';

import { CheckboxComponent } from './checkbox.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, IconModule],
  declarations: [CheckboxComponent],
  exports: [CheckboxComponent],
})
export class CheckboxComponentModule {}
